type ResumeListener = () => void

/** Subscribe to WebView restoration signals without owning authentication decisions. */
export function subscribeToCaigouChinaResume(listener: ResumeListener) {
  let wasHidden = document.visibilityState === 'hidden'

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      wasHidden = true
      return
    }
    if (!wasHidden) {
      return
    }
    wasHidden = false
    listener()
  }

  const handlePageShow = (event: PageTransitionEvent) => {
    if (event.persisted) {
      listener()
    }
  }

  document.addEventListener('visibilitychange', handleVisibilityChange)
  window.addEventListener('pageshow', handlePageShow)

  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
    window.removeEventListener('pageshow', handlePageShow)
  }
}
